import {Controller} from "stimulus";

export default class extends Controller {
    connect() {
        this.holder = this.element.querySelector(".fast-widget-holder");
        this.open = this.element.querySelector(".fast-widget-open");
        this.close = this.element.querySelector(".fast-widget-close");
    }

    toggleWidget(event) {
        const isOpen = this.holder.style.display === "block";

        if (isOpen) {
            // Hide the widget
            this.holder.style.display = "none";
            this.open.style.display = "inline";
            this.close.style.display = "none";
        } else {
            // Show the widget
            this.holder.style.display = "block";
            this.open.style.display = "none";
            this.close.style.display = "inline";
        }
    }
}
